/* eslint-disable no-nested-ternary */
import { useState } from 'react';
import Avatar from '@atoms/Avatar';
import Bin from '../public/images/InteractionPage/dynamic-svg/bin.svg';
import { computeLuminance, getOptimalTextColor } from '@lib/interactionHelper';

interface LinkLibraryItemProps {
  question: any;
  index: number;
  toggleCheckbox: (index: number) => void;
  currentRosFeature: any;
  handleDelete?: (index: number, isQuickQuestion?: boolean) => void;
  isResult: boolean;
  showUserName?: boolean;
  interactionType: string;
  selectedFilter: string;
  fontFamily?: any;
  fontSize?: string;
}

const LinkLibraryItem = ({
  question,
  index,
  toggleCheckbox,
  currentRosFeature,
  handleDelete,
  isResult,
  showUserName = false,
  interactionType,
  selectedFilter,
  fontFamily,
  fontSize,
}: LinkLibraryItemProps) => {
  const [deleteItems, setDeleteItems] = useState(false);
  const [, setValidUrl] = useState(true);

  const getTruncatedName = (str: string) => {
    if (str.length > 16) return `${str.slice(0, 16)}...`;
    return str;
  };

  const verifyLink = (str: string) => {
    if (!str.startsWith('http')) {
      return `https://${str}`;
    }
    return str;
  };

  let textColor = '#FFFFFF';
  let bgColor = '#000000';

  if (interactionType === 'Quick Questions') {
    textColor = currentRosFeature?.color?.quickQuestionTextColor || '#FFFFFF';
    bgColor = currentRosFeature?.color?.quickQuestionBgColor || '#000000';
  } else if (interactionType === 'linkLibrary') {
    textColor = currentRosFeature?.color?.linkLibraryTextColor || '#FFFFFF';
    bgColor = currentRosFeature?.color?.linkLibraryBgColor || '#000000';
  }

  const [isHovered, setIsHovered] = useState(false);
  
  const hoverBgColor = '#222222';
  const textHoverColor = isHovered ? getOptimalTextColor(hoverBgColor) : textColor;
  return (
    <div
      onMouseEnter={() => !isResult && setDeleteItems(true)}
      onMouseLeave={() => setDeleteItems(false)}
      className="w-full mt-4 z-2">
      <div onMouseOver={() => !isResult && setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} className={`w-full px-3 py-2.5 xl:pr-0 pr-7 ${(!question.is_checked && !isResult) && 'hover:bg-gray-30 hover:rounded-lg'}`}>
        <div className='flex items-center justify-between'>
          <div className='flex items-center flex-1'>
            <span className={`flex flex-none items-center cursor-default justify-center ${question.is_checked ? 'bg-gray-30 opacity-80' : deleteItems ? 'bg-white text-black' : 'bg-gray-50  text-white'} rounded w-8 h-8 font-Poppins text-base font-medium leading-4 mr-6`}>{Number(index) + 1}</span>

            {(interactionType === 'Quick Questions' || (interactionType === 'linkLibrary' && selectedFilter === 'Email Id'))
              ? <text style={{ color: isResult ? textColor : textHoverColor, ...fontFamily, fontSize }} className={`${isResult ? 'w-full' : 'w-full'} cursor-default py-0.5
              ${isResult ? 'text-lg' : ''} leading-6 font-medium  focus:outline-none line-clamp-1 hover:line-clamp-6
              ${question.is_checked ? 'opacity-60' : 'opacity-100'}
						`}>
                {question?.body?.split(' ').map((word: string) => (word.length > 52 ? word.replace(/(.{52})/g, '$1-') : word)).join(' ')}
              </text>
              : <div className='flex items-center space-x-2' >
                <a href={verifyLink(question.body)} target='_blank' >
                  <img onError={() => setValidUrl(false)} src={question.link_type === 'email' ? '/images/linkLibrary/emailSelect.svg' : '/images/linkLibrary/default_web_icon.png'} className='w-8' alt={'favicon_image'} />
                </a>

                <a href={verifyLink(question.body)} target="_blank" className={`w-full cursor-pointer py-0.5
              ${isResult ? 'text-base' : 'text-2xl'} leading-8 font-medium focus:outline-none line-clamp-1 ${!isResult && 'hover:line-clamp-6'}
              ${question.is_checked ? 'opacity-60' : 'opacity-100'}
              `}
                style={{ color: isResult ? textColor : textHoverColor, fontSize, ...fontFamily }}
                >
                  {question?.body?.split(' ').map((word: string) => (word.length > 52 ? word.replace(/(.{52})/g, '$1-') : word)).join(' ')}
                </a>
              </div>
            }
          </div>

          <div className={`flex flex-row justify-between ${showUserName ? 'xl:w-80 w-60' : 'xl:w-21 w-17'} ${isResult ? "w-fit" : ""} ml-4`} >
            {showUserName && <div className={`flex flex-row items-center rounded ${question.is_checked ? 'bg-gray-30 text-neutral-95' : 'bg-gray-40  text-white'} }`}>
              {(question.platform_type !== 'youtube' || !question?.raw_payload?.profileUrl) ? <Avatar className='ml-1 flex-0' textClass='text-xs' isProfile={true} name={question?.username} w='6' h='6' />
                : <img
                  className='ml-1 w-6 h-6 rounded-full'
                  src={question?.raw_payload?.profileUrl}
                  alt="profile-picture"
                />}
              <text className='max-w-36 whitespace-nowrap font-medium text-xs leading-3  py-2.5 px-3'>{getTruncatedName(question.username)}</text>
            </div>}
            {(deleteItems && !question.is_checked && handleDelete) && (
              <div className='flex  xl:ml-0 ml-3'>
                <div className='w-10 h-8 mr-1 cursor-pointer' onClick={() => handleDelete(index, true)}>
                  <Bin className={'fill-current text-white self-center group-hover:block cursor-pointer m-auto'} width="14" height="30" />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div >
  );
};

export default LinkLibraryItem;
